import { render, staticRenderFns } from "./BfInput.vue?vue&type=template&id=98311e86&"
import script from "./BfInput.vue?vue&type=script&lang=js&"
export * from "./BfInput.vue?vue&type=script&lang=js&"
import style0 from "./BfInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports